module.exports = __webpack_public_path__ + "static/media/UrbanSportsClub_Logo_Combo_White.0191a415.png";